import { getFromAttributeAndString } from '@/services/compiledPollService.js'
import { toast } from '@/services/toast.js'
import TranslationProvider from '@/provider/translations.js'

export function mergeObjects(target, defaults) {
  if (typeof target !== 'object' || target === null || Array.isArray(target)) {
    return Array.isArray(target) ? target : defaults;
  }

  if (typeof defaults !== 'object' || defaults === null || Array.isArray(defaults)) {
    return Array.isArray(defaults) ? defaults : target;
  }

  const merged = { ...defaults };

  for (const key of Object.keys(target)) {
    if (key in defaults) {
      merged[key] = mergeObjects(target[key], defaults[key]);
    } else {
      merged[key] = target[key];
    }
  }

  return merged;
}

export const formatImporto = (attributi) => {
  const amount = attributi['gec.amount']
  const currency = attributi['gec.amount.currency']
  const precision = parseInt(attributi['gec.amount.precision'], 10)

  if (!amount || !currency || isNaN(precision)) return ''

  const numberFormat = new Intl.NumberFormat('it-IT', {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision
  }).format(parseFloat(amount))

  return `${numberFormat} ${currency}`
}

export const pillColor = (poll) => {
  switch (poll['state']) {
    case 'draft':
      return 'bg-secondary'
    case 'to_be_compiled':
      return 'bg-warning text-dark'
    case 'confirmed':
      return 'bg-primary'
    case 'approved':
    case 'approved_office':
      return 'bg-success'
    case 'wont_do':
    case 'not_evaluated':
      return 'bg-light text-dark'
    default:
      return 'bg-info text-dark'
  }
}

export const splitSuppliers = (suppliersString) => {
  return suppliersString?.split('|||').join(', ')
}

export const sanitizeInputAmount = (importo) => {
  return importo.replace(',', '.').replace(/[^0-9.]/g, '').replace(/^(\d*\.\d{0,2}).*$/, '$1')
}

export function buildFilterQuery(filters = {}) {
  const hasValues = Object.values(filters).some(v => v !== null && v !== '' && v !== undefined)
  if (!hasValues) {
    return ''
  }

  const query = Object.entries(filters)
    .filter(([, value]) => value !== null && value !== '' && value !== undefined)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&')

  return query ? `&attribute_filters=1&${query}` : ''
}

export const calcPerc = (answer, totAnswers) => {
  let num = answer.num ?? 0;
  let tot = totAnswers[answer.state] ?? 0;

  if(tot === 0){
    return 0;
  }

  let percentage = (num / tot) * 100;
  return percentage.toFixed(2);
}

export const sidebarGroupedRoute = (router) => {
  return router.getRoutes().reduce((acc, route) => {
    const group = route.meta.sidebarGroup || false
    const sidebar = route.meta.sidebar || false

    if (!group || !sidebar) return acc

    if (!acc[group]) {
      acc[group] = []
    }

    if (route?.meta?.permissions?.canView) {
      acc[group].push(route)
    }

    if (acc[group].length === 0) {
      delete acc[group]
    }

    return acc
  }, {})
}

export const getAttributeList = async (attribute, fullSearch = '') => {
  if (fullSearch.length < 3) {
    return []
  }

  try {
    return await getFromAttributeAndString({
      fullSearch: fullSearch,
      attribute: attribute
    })

  } catch (error) {
    toast.create(TranslationProvider.getTrans('app.network_error'), 'error')
  }
}

export const searchSelect = async (searchQuery, loading, attribute) => {
  loading(true);

  const response = await getAttributeList(attribute, searchQuery);
  loading(false);
  return response.data ?? [];
}
